import { useState, useEffect } from 'react';
import client from '../../../shared/api/client';

export const EMPTY = { contacts: [], organizations: [], deals: [], grants: [], tasks: [], total: 0, capped: false };

export default function useCrmSearch(teamId) {
  const [q, setQ] = useState('');
  const [data, setData] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);

  const term = q.trim();
  const flat = [...data.contacts, ...data.organizations, ...data.deals, ...(data.grants || []), ...data.tasks];
  const seeAllHref = `/teams/${teamId}/crm/fans?search=${encodeURIComponent(term)}`;

  useEffect(() => {
    if (!term || !teamId) { setData(EMPTY); setOpen(false); return undefined; }
    setOpen(true);
    setLoading(true);
    let live = true;
    const t = setTimeout(() => {
      client.get(`/teams/${teamId}/crm_search.json`, { params: { q: term } })
        .then(({ data: res }) => { if (live) { setData(res || EMPTY); setLoading(false); } })
        .catch(() => { if (live) { setData(EMPTY); setLoading(false); } });
    }, 250);
    return () => { live = false; clearTimeout(t); };
  }, [term, teamId]);

  useEffect(() => { setActive(-1); }, [data]);

  const go = (href) => { if (href) window.location.href = href; };

  const onKeyDown = (e) => {
    if (e.key === 'Escape') { setOpen(false); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive((i) => Math.min(i + 1, flat.length - 1)); return; }
    if (e.key === 'ArrowUp') { e.preventDefault(); setActive((i) => Math.max(i - 1, -1)); return; }
    if (e.key === 'Enter') {
      if (active >= 0 && flat[active]) go(flat[active].href);
      else if (term) go(seeAllHref);
    }
  };

  return { q, setQ, data, loading, open, setOpen, active, setActive, term, flat, seeAllHref, go, onKeyDown };
}
